import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import LabeledDropdown from '../common/form-components/labeled-dropdown/LabeledDropdown'
import AccountingEntryService from '../../services/accounting-entry/accountingEntry.service'

const WorkerSelector = ({
  companyCode,
  disabled = false,
  value,
  onChange,
  filter,
}) => {
  const [workers, setWorkers] = useState([])

  useEffect(() => {
    retrieveWorkers()
  }, [])

  const retrieveWorkers = async () => {
    const response = await AccountingEntryService.workers.getWorkers({
      companyCode,
      filter,
      sort: 'workerName',
    })
    if (response && response?.resp) setWorkers(response?.resp)
  }

  // const renderWorker = (data) => (
  //   <>
  //     <span className="text-monospace">{data.workerCode}</span>
  //     &nbsp;&nbsp;
  //     <span>{data.workerName}</span>
  //   </>
  // )

  return (
    <LabeledDropdown
      idLabel="worker"
      name="workerCode"
      disabled={disabled}
      required
      options={workers}
      optionLabel="workerName"
      optionValue="workerCode"
      showClear={value}
      value={value}
      filter
      onChange={onChange}
    />
  )
}
export default WorkerSelector
